import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FacturaService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  //Catalogo de bill

  getAllfactura(token: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/bill/all`, body, { headers });
  }

  // getYears(token: string): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Authorization': `${token}`
  //   });

  //   return this.http.get(`${this.apiUrl}/bill/year`, { headers });
  // }

  createfactura(factura: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/bill`, factura, { headers });
  }

  editfactura(factura: any, facturaId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.put(`${this.apiUrl}/bill/${facturaId}`, factura, { headers });
  }

  deletefactura(facturaId: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.delete(`${this.apiUrl}/bill/${facturaId}`, { headers });
  }

  //Catalogo de bill

  getAllrefactura(token: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/rebill/all`, body, { headers });
  }

  createrefactura(factura: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.post(`${this.apiUrl}/rebill`, factura, { headers });
  }

  getbuscarrefactura(id: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.get(`${this.apiUrl}/bill/${id}`, { headers });
  }

  getobtenerrefactura(id: any, idOrigen: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

  
    return this.http.post(`${this.apiUrl}/rebill/${id}`, idOrigen, { headers });
  }

  deleterefactura(refacturaId: any, idRefactura: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });  
    return this.http.put(`${this.apiUrl}/rebill/liberate/${refacturaId}`, idRefactura ,  { headers });
  }  

  SaveDocument(document: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });
    return this.http.post(`${this.apiUrl}/bill/newDocument`, document, { headers });
  }

  getDocuments(FKId_Factura: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

    return this.http.get(`${this.apiUrl}/bill/allDocuments/${FKId_Factura}`, { headers });
  }

  deleteDocument(Id_Documento: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `${token}`
    });

   return this.http.delete(`${this.apiUrl}/bill/deleteDocument/${Id_Documento}`, { headers });
  }

    //Estados

    comentarios(factura: any, facturaId: any, token: string): Observable<any> {
      const headers = new HttpHeaders({
        'Authorization': `${token}`
      });
  
      return this.http.put(`${this.apiUrl}/bill/Observations/${facturaId}`, factura, { headers });
    }

    comentariosR(factura: any, facturaId: any, token: string): Observable<any> {
      const headers = new HttpHeaders({
        'Authorization': `${token}`
      });
  
      return this.http.put(`${this.apiUrl}/rebill/Observations/${facturaId}`, factura, { headers });
    }
  
    cambioEstatus(factura: any, facturaId: any, token: string): Observable<any> {
      const headers = new HttpHeaders({
        'Authorization': `${token}`
      });
  
      return this.http.put(`${this.apiUrl}/bill/VoBo/${facturaId}`, factura, { headers });
    }

    cambioEstatusR(factura: any, facturaId: any, token: string): Observable<any> {
      const headers = new HttpHeaders({
        'Authorization': `${token}`
      });
  
      return this.http.put(`${this.apiUrl}/rebill/VoBo/${facturaId}`, factura, { headers });
    }

    ValidacionTiempo(factura: any, facturaId: any, token: string): Observable<any> {
      const headers = new HttpHeaders({
        'Authorization': `${token}`
      });
  
      return this.http.put(`${this.apiUrl}/bill/ValidateTime/${facturaId}`, factura, { headers });
    }

    validacionContadores(nombreContador: any, token: string): Observable<any> {
      const headers = new HttpHeaders({
         'Authorization': `${token}`,
         'Content-Type': 'application/json'
      });
   
      let body ={
        type : nombreContador
      }
   
      // Hacemos la petición GET con los parámetros en la URL
      return this.http.post(`${this.apiUrl}/dashboard/list`, body, { headers});
   }
   
    
}
